import axios from 'axios'
import ThreeCAuthService from './ThreeCAuthService'
import threeCConfig from './ThreeCConfig'

class ThreeCApiService {
  get baseURL () {
    return threeCConfig.API_BASE_URL
  }

  getAuthHeaders () {
    return ThreeCAuthService.getAuthHeaders()
  }

  async getCampaigns () {
    try {
      const response = await axios.get(`${this.baseURL}/agent/campaigns`, {
        headers: this.getAuthHeaders()
      })

      return response.data.data || []
    } catch (error) {
      console.error('Erro ao buscar campanhas:', error)
      throw new Error(`Falha ao buscar campanhas: ${error.response.data.message || error.message}`)
    }
  }

  async agentLogin (campaignId) {
    try {
      const response = await axios.post(`${this.baseURL}/agent/login`, {
        mode: 'dialer',
        campaign: campaignId
      }, {
        headers: this.getAuthHeaders()
      })

      return response.data
    } catch (error) {
      if (error.response.status === 422) {
        throw new Error('AGENT_ALREADY_LOGGED_IN')
      }
      throw new Error(`Falha no login: ${error.response.data.message || error.message}`)
    }
  }

  async agentLogout () {
    try {
      const response = await axios.post(`${this.baseURL}/agent/logout`, {}, {
        headers: this.getAuthHeaders()
      })

      return response.data
    } catch (error) {
      throw new Error(`Falha no logout: ${error.response.data.message || error.message}`)
    }
  }

  async enterManualMode () {
    try {
      const response = await axios.post(`${this.baseURL}/agent/manual_call/enter`, {}, {
        headers: this.getAuthHeaders()
      })

      return response.data
    } catch (error) {
      throw new Error(`Falha ao entrar no modo manual: ${error.response.data.message || error.message}`)
    }
  }

  async dialNumber (phoneNumber) {
    try {
      const response = await axios.post(`${this.baseURL}/agent/manual_call/dial`, {
        phone: phoneNumber
      }, {
        headers: this.getAuthHeaders()
      })

      return response.data
    } catch (error) {
      throw new Error(`Falha ao discar: ${error.response.data.message || error.message}`)
    }
  }

  async hangupCall (callId) {
    try {
      const response = await axios.post(`${this.baseURL}/agent/call/${callId}/hangup`, {}, {
        headers: this.getAuthHeaders()
      })

      return response.data
    } catch (error) {
      throw new Error(`Falha ao desligar chamada: ${error.response.data.message || error.message}`)
    }
  }

  async enterWorkBreak (workBreakId = 1) {
    try {
      const response = await axios.post(`${this.baseURL}/agent/work_break/${workBreakId}/enter`, {}, {
        headers: this.getAuthHeaders()
      })

      return response.data
    } catch (error) {
      throw new Error(`Falha ao entrar em pausa: ${error.response.data.message || error.message}`)
    }
  }

  async exitWorkBreak () {
    try {
      const response = await axios.post(`${this.baseURL}/agent/work_break/exit`, {}, {
        headers: this.getAuthHeaders()
      })

      return response.data
    } catch (error) {
      throw new Error(`Falha ao sair da pausa: ${error.response.data.message || error.message}`)
    }
  }

  async downloadRecording (callId) {
    try {
      const response = await axios.get(`${this.baseURL}/calls/${callId}/recording`, {
        headers: this.getAuthHeaders(),
        responseType: 'blob'
      })

      return response
    } catch (error) {
      throw new Error(`Falha ao fazer download da gravação: ${error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message}`)
    }
  }

  formatPhoneNumber (phoneNumber) {
    const cleanNumber = phoneNumber.replace(/\D/g, '')

    if (cleanNumber.startsWith('55') && cleanNumber.length >= 12) {
      return cleanNumber
    }

    if (cleanNumber.length === 11) {
      return `55${cleanNumber}`
    }

    if (cleanNumber.length === 10) {
      return `559${cleanNumber}`
    }

    return cleanNumber
  }
}

export default new ThreeCApiService()



// WEBPACK FOOTER //
// ./src/shared/services/voip/ThreeCApiService.js